export default __webpack_public_path__ + "static/quiz-2-8b415e9cc423b80a9bc071c1a564cce4.png";